import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProactiveSupportActivitiesRoute: InvariantJiraRoute = {
	name: 'servicedesk-proactive-support-activities',
	path: '/jira/servicedesk/projects/:projectKey/proactive-support/activities',
	exact: true,
};
